module.exports = __webpack_public_path__ + "static/media/apoio.fe42740b.svg";